import type { PostLayoutConfig } from './types';

type PreviewAspectRatio = 'landscape' | 'portrait';

export function resolveEditorPreviewPostLayout({
  postLayout,
  effectiveAspectRatio,
}: {
  postLayout: PostLayoutConfig | null;
  effectiveAspectRatio: PreviewAspectRatio;
}): PostLayoutConfig | null {
  return effectiveAspectRatio === 'landscape' || effectiveAspectRatio === 'portrait'
    ? postLayout
    : null;
}
